import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";

async function fetchConstantData(status, month) {
  const searchOptions = {};
  const searchOptionByMonth = {};

  if (status) {
    searchOptions.status = status;
    searchOptionByMonth.status = status;
  }else{
    searchOptions.status = "APPROVED";
    searchOptionByMonth.status = "APPROVED";
  }

  if (month) {
    searchOptionByMonth.month = month;
  }

  const searchQueryParams = new URLSearchParams(searchOptions).toString();
  const searchQueryParamByMonths = new URLSearchParams(
    searchOptionByMonth
  ).toString();

  // Fetch constant data concurrently
  const [bookingByMonth] = await Promise.all([
    clientAPI(
      "get",
      `/booking/reportBlockAndProject?${searchQueryParamByMonths}`
    ),
  ]);

  // Index data by 'id' to improve lookup performance
  return {
    bookingByMonth: bookingByMonth?.items,
  };
}

export function useCategoriesBookingByMonthData(shouldFetch, status, month) {
  // Fetch constant data once
  const {
    data: bookingByMonthData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["statementDetail2", status, month],
    queryFn: () => fetchConstantData(status, month),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    bookingByMonthData,
    isLoading,
    isFetching,
    refetch,
  };
}
